import swal from "sweetalert";
import {InitPage} from "../../index";
import {ElcProductionAddEmployee} from "./add_employee";
import * as Toastr from "toastr";


declare const saveEmployeeLoggedTimes;
declare const snapshotPath;

export class ElcProductionEmployeeLogTime {
    constructor() {
        $("#emp-checkALL").on("click", () => {
            $.each($(".emp_bulk_update"), function(){
                $(this).prop("checked", $("#emp-checkALL").is(":checked"));
            });
        });

        $("#add-employee-logged-time-btn").on("click", () => {
            const x = document.querySelector("#employee-logged-time-form");
            if ((x as HTMLFormElement).reportValidity()) {
                $.ajax({
                    url: `${saveEmployeeLoggedTimes}?${$.param($(".non-prod-data").serializeArray())}`
                }).then((response) => {
                    console.log(response);
                    if (response.message == "ok") {
                        Toastr.success("Saved", "Saved");
                        window.location = snapshotPath;
                    } else {
                        Toastr.error(response.message,"Error");
                    }
                });
            }
        });

        $("#emp-bulk-update").on("click", () => {
            const x = document.querySelector("#employee-logged-time-form");
            if($(".emp-checkbox-item:checked").length > 0){
                let selectedEmployees = [];
                $.each($(".emp-checkbox-item:checked"), (i, e) => {
                    console.log(e);
                    selectedEmployees.push($(e).val());
                });
                if ((x as HTMLFormElement).reportValidity()) {
                    $.ajax({
                        url: `${saveEmployeeLoggedTimes}?${$.param($(".emp_bulk_update").serializeArray())}`,
                        data: { selected_employees: selectedEmployees, bulk_update: true }
                    }).then((response) => {
                        console.log(response);
                        if (response.message == "ok") {
                            Toastr.success("Saved", "Saved");
                            window.location.href = window.location.href.replace('#','');
                        } else {
                            Toastr.error(response.message,"Error");
                        }
                    });
                }
            } else {
                Toastr.error("no Employee selected");
            }
        });

        $("#emp-bulk-update-time").on("click", () => {
            $.ajax({
                url: `${saveEmployeeLoggedTimes}?${$.param($(".change_time_snapshot").serializeArray())}`,
                data: { change_time: true }
            }).then((response) => {
                console.log(response);
                if (response.message == "ok") {
                    Toastr.success("Saved", "Saved");
                    window.location.href = window.location.href.replace('#','');
                } else {
                    Toastr.error(response.message,"Error");
                }
            });
        });
    }
}

export function LoadPage() {
    InitPage("elc productions", () => {
        InitPage("employee_log_times", () => {
            const c = new ElcProductionEmployeeLogTime();
            const d = new ElcProductionAddEmployee();
        });

        InitPage("work_order_reports log_time", () => {
            const c = new ElcProductionEmployeeLogTime();
            const d = new ElcProductionAddEmployee();
        });
    });
}
